import { ShareButtonComponent } from "controls/share-button.component";

/**
 * Global place to access ShareButton in order to configure within different routes.
 * Should probably use something like Redux, but keeping it simple for now. 
 */
export class ShareService {
    public static shareButton: ShareButtonComponent;
}
